import axios, { type AxiosError } from "axios";
import { wordProcessorHost } from "./config";
import { sessionStatusExpired, sessionStatusParam } from "./types";

const prefix = "/api/v1";
export const privateApi = axios.create({ baseURL: prefix });
export const wordProcessorApi = axios.create({ baseURL: wordProcessorHost });

privateApi.interceptors.response.use(
  (response) => response,
  async function (error: AxiosError) {
    if (error.response?.status === 401) {
      const redirect = encodeURIComponent(window.location.pathname);
      window.location.replace(
        `/login?${sessionStatusParam}=${sessionStatusExpired}&redirect=${redirect}`,
      );
    }
    return Promise.reject(error);
  },
);
